export const blockIconsCommunicationLinkNew = (
	<span className='material-symbols-outlined'>link</span>
);
